// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.f_kos_page {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ── Header ── */
.f_kos_header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  padding-top: 6px;
  flex-wrap: wrap;
}

.f_kos_header-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 4px;
}

.f_kos_header-icon {
  width: 26px;
  height: 26px;
  color: #0860e6;
  flex-shrink: 0;
}

.f_kos_title {
  font-size: 22px;
  font-weight: 700;
  color: #0b0b0b;
  margin: 0;
}

.f_kos_subtitle {
  font-size: 13px;
  color: #6b6b6b;
  margin: 0;
  max-width: 500px;
}

.f_kos_header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  padding-top: 6px;
  flex-wrap: wrap;
}

.f_kos_filter-btn-wrapper {
  position: relative;
  display: inline-flex;
}

.f_kos_filter-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  min-width: 18px;
  height: 18px;
  background: #1976d2;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  pointer-events: none;
}

/* ── Tabs ── */
.f_kos_tabs {
  display: flex;
  gap: 4px;
  background: #f0f0f0;
  border-radius: 8px;
  padding: 4px;
  width: fit-content;
  max-width: 100%;
  overflow-x: auto;
  flex-shrink: 0;
}

.f_kos_tab {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 7px 16px;
  font-size: 13px;
  font-weight: 500;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  background: transparent;
  color: #6b6b6b;
  transition: background 0.15s, color 0.15s;
  font-family: inherit;
  white-space: nowrap;
}

.f_kos_tab-active {
  background: #ffffff;
  color: #0b0b0b;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.f_kos_tab-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  background: #0860e6;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  border-radius: 10px;
  padding: 0 5px;
}

/* ── Table card ── */
.f_kos_table-card {
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  overflow: hidden;
}

.f_kos_table-scroll {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.f_kos_no-results {
  font-size: 13px;
  color: #6b6b6b;
  padding: 32px 20px;
  text-align: center;
  margin: 0;
}

/* ── Cell helpers ── */
.f_kos_id-link {
  color: #0860e6;
  font-weight: 500;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
}

.f_kos_id-link:hover {
  text-decoration: underline;
}

.f_kos_dest-cell {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #0b0b0b;
  font-size: 13px;
}

.f_kos_dest-icon {
  width: 16px;
  height: 16px;
  color: #6b6b6b;
  flex-shrink: 0;
}

.f_kos_items-cell {
  display: flex;
  align-items: baseline;
  gap: 4px;
  white-space: nowrap;
  font-size: 13px;
}

.f_kos_items-unit {
  color: #6b6b6b;
  font-size: 13px;
}

.f_kos_items-sku {
  color: #949494;
  font-size: 13px;
}

/* ── Dispatch Mode Badges ── */
.f_kos_mode-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  border: 1px solid #d0d0d0;
  background: #fff;
  color: #4b4b4b;
  white-space: nowrap;
}

.f_kos_mode-direct    { border-color: #c0cfe8; color: #1a52a8; background: #f0f5ff; }
.f_kos_mode-stock     { border-color: #c8d8c8; color: #2a6a3a; background: #f0faf0; }
.f_kos_mode-consignment { border-color: #d8c8e8; color: #6a2a9a; background: #f8f0ff; }
.f_kos_mode-periodic  { border-color: #e8d8b8; color: #9a6a0a; background: #fffaf0; }
.f_kos_mode-po        { border-color: #d0d0d0; color: #4b4b4b; background: #f5f5f5; }

/* ── Status Badges ── */
.f_kos_status-badge {
  display: inline-block;
  padding: 3px 12px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.f_kos_status-ready {
  background: #e6f7ed;
  color: #219647;
}

.f_kos_status-pending {
  background: #f0f0f0;
  color: #6b6b6b;
}

/* ── Return Type Badge ── */
.f_kos_return-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  border: 1px solid #d0d0d0;
  background: #fff;
  color: #4b4b4b;
  white-space: nowrap;
}

/* ── Action link ── */
.f_kos_action-link {
  background: none;
  border: none;
  color: #0860e6;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
  font-family: inherit;
  white-space: nowrap;
}

.f_kos_action-link:hover {
  text-decoration: underline;
}

/* ── Row checkbox ── */
.f_kos_row-check {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  cursor: pointer;
  accent-color: #0860e6;
}

/* ── Tab-level actions (Batch Pickup) ── */
.f_kos_tab-actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

/* ── Day-Close Recon Panel ── */
.f_kos_recon-panel {
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  overflow: hidden;
}

.f_kos_recon-panel-header {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 18px 20px 14px;
  border-bottom: 1px solid #f0f0f0;
}

.f_kos_recon-icon {
  width: 20px;
  height: 20px;
  color: #0860e6;
  flex-shrink: 0;
  margin-top: 2px;
}

.f_kos_recon-title {
  font-size: 15px;
  font-weight: 600;
  color: #0b0b0b;
  margin: 0 0 4px 0;
}

.f_kos_recon-subtitle {
  font-size: 13px;
  color: #6b6b6b;
  margin: 0;
}

/* ── Recon qty colors ── */
.f_kos_qty-red {
  color: #e90000;
  font-weight: 500;
  font-size: 13px;
}

.f_kos_qty-blue {
  color: #0860e6;
  font-weight: 600;
  font-size: 13px;
}

/* ── Variance Badges ── */
.f_kos_variance-matched {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  background: #f0f0f0;
  color: #6b6b6b;
}

.f_kos_variance-warning {
  display: inline-flex;
  flex-direction: column;
  gap: 3px;
}

.f_kos_variance-label {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  background: #ffe9e9;
  color: #e90000;
}

.f_kos_variance-detail {
  font-size: 13px;
  color: #6b6b6b;
  padding-left: 2px;
}

/* ── Responsive ──────────────────────────────────────────────────────────────── */

/* Tablet: header wraps, actions shift right */
@media (max-width: 900px) {
  .f_kos_header {
    flex-direction: column;
    align-items: flex-start;
  }

  .f_kos_header-actions {
    padding-top: 0;
    width: 100%;
    justify-content: flex-end;
  }

  .f_kos_title {
    font-size: 18px;
  }
}

/* Small tablet: tabs scroll, tab-actions stack */
@media (max-width: 640px) {
  .f_kos_tabs {
    width: 100%;
  }

  .f_kos_tab {
    padding: 7px 12px;
  }

  .f_kos_tab-actions {
    justify-content: flex-start;
  }

  .f_kos_recon-panel-header {
    flex-direction: column;
    gap: 6px;
  }
}

/* Mobile: tighten spacing */
@media (max-width: 480px) {
  .f_kos_header-actions {
    gap: 6px;
  }

  .f_kos_title {
    font-size: 16px;
  }

  .f_kos_subtitle {
    max-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/Kitchen-OS/components/fulfillment-kitchenOS.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;AACtB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,yCAAyC;EACzC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,wBAAwB,qBAAqB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AACpF,wBAAwB,qBAAqB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AACpF,0BAA0B,qBAAqB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AACtF,wBAAwB,qBAAqB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AACpF,wBAAwB,qBAAqB,EAAE,cAAc,EAAE,mBAAmB,EAAE;;AAEpF,wBAAwB;AACxB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,2BAA2B;AAC3B;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA,mFAAmF;;AAEnF,8CAA8C;AAC9C;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,iDAAiD;AACjD;EACE;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".f_kos_page {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* ── Header ── */\n.f_kos_header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  padding-top: 6px;\n  flex-wrap: wrap;\n}\n\n.f_kos_header-title-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 4px;\n}\n\n.f_kos_header-icon {\n  width: 26px;\n  height: 26px;\n  color: #0860e6;\n  flex-shrink: 0;\n}\n\n.f_kos_title {\n  font-size: 22px;\n  font-weight: 700;\n  color: #0b0b0b;\n  margin: 0;\n}\n\n.f_kos_subtitle {\n  font-size: 13px;\n  color: #6b6b6b;\n  margin: 0;\n  max-width: 500px;\n}\n\n.f_kos_header-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  padding-top: 6px;\n  flex-wrap: wrap;\n}\n\n.f_kos_filter-btn-wrapper {\n  position: relative;\n  display: inline-flex;\n}\n\n.f_kos_filter-badge {\n  position: absolute;\n  top: -6px;\n  right: -6px;\n  min-width: 18px;\n  height: 18px;\n  background: #1976d2;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 700;\n  border-radius: 9px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 4px;\n  pointer-events: none;\n}\n\n/* ── Tabs ── */\n.f_kos_tabs {\n  display: flex;\n  gap: 4px;\n  background: #f0f0f0;\n  border-radius: 8px;\n  padding: 4px;\n  width: fit-content;\n  max-width: 100%;\n  overflow-x: auto;\n  flex-shrink: 0;\n}\n\n.f_kos_tab {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 16px;\n  font-size: 13px;\n  font-weight: 500;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  background: transparent;\n  color: #6b6b6b;\n  transition: background 0.15s, color 0.15s;\n  font-family: inherit;\n  white-space: nowrap;\n}\n\n.f_kos_tab-active {\n  background: #ffffff;\n  color: #0b0b0b;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.f_kos_tab-count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 20px;\n  height: 20px;\n  background: #0860e6;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 700;\n  border-radius: 10px;\n  padding: 0 5px;\n}\n\n/* ── Table card ── */\n.f_kos_table-card {\n  background: #ffffff;\n  border: 1px solid #e6e6e6;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.f_kos_table-scroll {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.f_kos_no-results {\n  font-size: 13px;\n  color: #6b6b6b;\n  padding: 32px 20px;\n  text-align: center;\n  margin: 0;\n}\n\n/* ── Cell helpers ── */\n.f_kos_id-link {\n  color: #0860e6;\n  font-weight: 500;\n  font-size: 13px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.f_kos_id-link:hover {\n  text-decoration: underline;\n}\n\n.f_kos_dest-cell {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #0b0b0b;\n  font-size: 13px;\n}\n\n.f_kos_dest-icon {\n  width: 16px;\n  height: 16px;\n  color: #6b6b6b;\n  flex-shrink: 0;\n}\n\n.f_kos_items-cell {\n  display: flex;\n  align-items: baseline;\n  gap: 4px;\n  white-space: nowrap;\n  font-size: 13px;\n}\n\n.f_kos_items-unit {\n  color: #6b6b6b;\n  font-size: 13px;\n}\n\n.f_kos_items-sku {\n  color: #949494;\n  font-size: 13px;\n}\n\n/* ── Dispatch Mode Badges ── */\n.f_kos_mode-badge {\n  display: inline-block;\n  padding: 3px 10px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 500;\n  border: 1px solid #d0d0d0;\n  background: #fff;\n  color: #4b4b4b;\n  white-space: nowrap;\n}\n\n.f_kos_mode-direct    { border-color: #c0cfe8; color: #1a52a8; background: #f0f5ff; }\n.f_kos_mode-stock     { border-color: #c8d8c8; color: #2a6a3a; background: #f0faf0; }\n.f_kos_mode-consignment { border-color: #d8c8e8; color: #6a2a9a; background: #f8f0ff; }\n.f_kos_mode-periodic  { border-color: #e8d8b8; color: #9a6a0a; background: #fffaf0; }\n.f_kos_mode-po        { border-color: #d0d0d0; color: #4b4b4b; background: #f5f5f5; }\n\n/* ── Status Badges ── */\n.f_kos_status-badge {\n  display: inline-block;\n  padding: 3px 12px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.f_kos_status-ready {\n  background: #e6f7ed;\n  color: #219647;\n}\n\n.f_kos_status-pending {\n  background: #f0f0f0;\n  color: #6b6b6b;\n}\n\n/* ── Return Type Badge ── */\n.f_kos_return-badge {\n  display: inline-block;\n  padding: 3px 10px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 500;\n  border: 1px solid #d0d0d0;\n  background: #fff;\n  color: #4b4b4b;\n  white-space: nowrap;\n}\n\n/* ── Action link ── */\n.f_kos_action-link {\n  background: none;\n  border: none;\n  color: #0860e6;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  padding: 0;\n  font-family: inherit;\n  white-space: nowrap;\n}\n\n.f_kos_action-link:hover {\n  text-decoration: underline;\n}\n\n/* ── Row checkbox ── */\n.f_kos_row-check {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  cursor: pointer;\n  accent-color: #0860e6;\n}\n\n/* ── Tab-level actions (Batch Pickup) ── */\n.f_kos_tab-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 10px;\n}\n\n/* ── Day-Close Recon Panel ── */\n.f_kos_recon-panel {\n  background: #ffffff;\n  border: 1px solid #e6e6e6;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.f_kos_recon-panel-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 18px 20px 14px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.f_kos_recon-icon {\n  width: 20px;\n  height: 20px;\n  color: #0860e6;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.f_kos_recon-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #0b0b0b;\n  margin: 0 0 4px 0;\n}\n\n.f_kos_recon-subtitle {\n  font-size: 13px;\n  color: #6b6b6b;\n  margin: 0;\n}\n\n/* ── Recon qty colors ── */\n.f_kos_qty-red {\n  color: #e90000;\n  font-weight: 500;\n  font-size: 13px;\n}\n\n.f_kos_qty-blue {\n  color: #0860e6;\n  font-weight: 600;\n  font-size: 13px;\n}\n\n/* ── Variance Badges ── */\n.f_kos_variance-matched {\n  display: inline-block;\n  padding: 3px 10px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 500;\n  background: #f0f0f0;\n  color: #6b6b6b;\n}\n\n.f_kos_variance-warning {\n  display: inline-flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.f_kos_variance-label {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 600;\n  background: #ffe9e9;\n  color: #e90000;\n}\n\n.f_kos_variance-detail {\n  font-size: 13px;\n  color: #6b6b6b;\n  padding-left: 2px;\n}\n\n/* ── Responsive ──────────────────────────────────────────────────────────────── */\n\n/* Tablet: header wraps, actions shift right */\n@media (max-width: 900px) {\n  .f_kos_header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .f_kos_header-actions {\n    padding-top: 0;\n    width: 100%;\n    justify-content: flex-end;\n  }\n\n  .f_kos_title {\n    font-size: 18px;\n  }\n}\n\n/* Small tablet: tabs scroll, tab-actions stack */\n@media (max-width: 640px) {\n  .f_kos_tabs {\n    width: 100%;\n  }\n\n  .f_kos_tab {\n    padding: 7px 12px;\n  }\n\n  .f_kos_tab-actions {\n    justify-content: flex-start;\n  }\n\n  .f_kos_recon-panel-header {\n    flex-direction: column;\n    gap: 6px;\n  }\n}\n\n/* Mobile: tighten spacing */\n@media (max-width: 480px) {\n  .f_kos_header-actions {\n    gap: 6px;\n  }\n\n  .f_kos_title {\n    font-size: 16px;\n  }\n\n  .f_kos_subtitle {\n    max-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
